import React, { useState } from "react";
import { Button, TextField, Typography, Container, Box } from "@mui/material";
import { useSnackbar } from "../../context/SnackbarContext";
import { useRequestPasswordReset } from "../../api/user/use-request-password-reset";

export default function RequestResetPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { mutate, isPending } = useRequestPasswordReset();

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    mutate(
      { email },
      {
        onSuccess: () => {
          setSent(true);
          showSnackbar(
            "If this email exists, you will receive a reset email",
            "success"
          );
        },
        onError: () => showSnackbar("Something went wrong", "error"),
      }
    );
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Forgot Password?
        </Typography>
        <Typography sx={{ mt: 1, mb: 1 }}>
          Enter your email address and we'll send you a link to reset your
          password.
        </Typography>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            required
            label="Email Address"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={sent}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2 }}
            disabled={sent || isPending}
          >
            Send Reset Link
          </Button>
        </Box>
        {sent && (
          <Typography sx={{ mt: 2 }}>
            Check your email for a reset link.
          </Typography>
        )}
      </Box>
    </Container>
  );
}
